import styled from 'styled-components';

export const AcceptEmployeeWrapper = styled.div`
  .ant-form {
    margin-top: 20px;
    max-width: 1220px;
  }
  .ant-form-item {
    width: 288px;
  }
  .switcher-field {
    max-width: 50px;
  }
`;
